import { InstitutionPerimeterType } from 'store/state'

const hasAccessToManageServices = (
  isInternal: boolean,
  institutionPerimeter: InstitutionPerimeterType
): boolean => {
  const ACCESS_SERVICES = Boolean(
    parseInt(process?.env?.REACT_APP_ACCESS_SERVICES || '1', 10)
  )

  return !!(
    !isInternal &&
    ACCESS_SERVICES &&
    institutionPerimeter.allItems &&
    institutionPerimeter.allItems.length > 1
  )
}

export default hasAccessToManageServices
